// Accra uses UTC throughout the year. Prepare the following slate before evening publication.
export function streakPreparationDay(now=new Date()):string {
 return new Date(now.getTime()+(now.getUTCHours()>=17?86_400_000:0)).toISOString().slice(0,10);
}
export function streakBoardDay(now=new Date()):string {
 const evening=now.getUTCHours()*60+now.getUTCMinutes()>=20*60+30;
 return new Date(now.getTime()+(evening?86_400_000:0)).toISOString().slice(0,10);
}
export function streakPublicationAt(day:string):Date {
 return new Date(Date.parse(day+'T20:30:00Z')-86_400_000);
}
export function streakPhaseReady(phase:number,day:string,now=new Date(),onDemand=false):boolean {
 if(onDemand&&now.toISOString().slice(0,10)===day&&now.getTime()<Date.parse(streakSlateWindow(day).end))return true;
 if(phase<17)return true;
 if(now.getTime()>=Date.parse(day+'T00:00:00Z'))return false;
 return now.getTime()>=streakPublicationAt(day).getTime()-(phase===17?4*60_000:0);
}

// Each release owns one continuous 24-hour slate, including the preceding night.
export function streakSlateWindow(day:string):{start:string;end:string} {
 const end=Date.parse(day+'T21:00:00Z');
 return {start:new Date(end-86_400_000).toISOString(),end:new Date(end).toISOString()};
}
export function streakKickoffEligible(kickoff:string,day:string):boolean {
 const {start,end}=streakSlateWindow(day),time=Date.parse(kickoff);
 return time>=Date.parse(start)&&time<Date.parse(end);
}
